import React, { useEffect, useState } from "react";
import { Modal, Input, Button, Switch, DatePicker } from "antd";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { t } from "i18next";
import { toast } from "react-toastify";
import deleteicon from "../assets/Order/Delete.svg";

const ExpiryModal = ({
  visible,
  onClose,
  onSave,
  productIndex,
  initialData,
  purchaseQty,
  freeQty,
  initialAlertDays,
  initialExpiryAlert
}) => {

  const [expiryData, setExpiryData] = useState([
    {
      batchNumber: "",
      qty: "",
      manufactureDate: null,
      shelfLife: "",
      expiryDate: null,
    },
  ]);

  const [expiryAlert, setExpiryAlert] = useState(false);
  const [alertDays, setAlertDays] = useState("");
  const [totalQty, setTotalQty] = useState(0);

  useEffect(() => {
    if (visible) {
      if (initialData && initialData.length > 0) {
        setExpiryData(initialData);
        setExpiryAlert(initialExpiryAlert);
        setAlertDays(initialAlertDays);
      } else {
        setExpiryData([
          {
            batchNumber: "",
            qty: "",
            manufactureDate: null,
            shelfLife: "",
            expiryDate: null,
          },
        ]);
        setExpiryAlert(false);
        setAlertDays("");
      }
      setTotalQty(0);
    }
  }, [visible, initialData]);

  const handleAddRow = () => {
    if (expiryData.length < 10) {
      setExpiryData([
        ...expiryData,
        {
          batchNumber: "",
          qty: "",
          manufactureDate: null,
          shelfLife: "",
          expiryDate: null,
        },
      ]);
    } else {
      toast.error("You can only add up to 10 rows.");
    }
  };

  const handleChange = (index, key, value) => {
    const newData = [...expiryData];

    if (key === "qty" || key === "shelfLife") {
      let numericValue = parseInt(value, 10) || 0;
      if (numericValue < 0) numericValue = 0;

      newData[index][key] = numericValue;

      if (key === "qty") {
        const newTotalQty = newData.reduce(
          (acc, item) => acc + (item.qty || 0),
          0
        );
        setTotalQty(newTotalQty);
      }
    } else {
      newData[index][key] = value;
    }

    setExpiryData(newData);
  };

const handleManufactureDateChange = (index, date) => {
  const newData = [...expiryData];
  const currentExpiry = newData[index].expiryDate;

  // ❌ If new manufacture date > expiry date → block it
  if (
    date &&
    currentExpiry &&
    moment(date).isAfter(currentExpiry, "day")
  ) {
    toast.error("Manufacture date cannot be greater than expiry date.");
    return;
  }

  newData[index].manufactureDate = date;

  // ✅ recalculate shelf life
  if (date && currentExpiry) {
    newData[index].shelfLife = calculateShelfLife(date, currentExpiry);
  }

  setExpiryData(newData);
};

const handleDateChange = (index, date) => {
  const newData = [...expiryData];
  const currentMfg = newData[index].manufactureDate;

  // ❌ If expiry < manufacture → block it
  if (
    date &&
    currentMfg &&
    moment(date).isBefore(currentMfg, "day")
  ) {
    toast.error("Expiry date cannot be less than manufacture date.");
    return;
  }

  newData[index].expiryDate = date;

  // ✅ recalculate shelf life
  if (date && currentMfg) {
    newData[index].shelfLife = calculateShelfLife(currentMfg, date);
  }

  setExpiryData(newData);
};
  

const handleSave = () => {

  if (totalQty > purchaseQty + freeQty) {
    toast.error(
      "Total quantity cannot exceed purchase quantity plus free quantity."
    );
    return;
  }

  for (let item of expiryData) {
    if (item.qty && !item.manufactureDate && !item.expiryDate) {
      toast.error("Please enter either Manufacture Date or Expiry Date.");
      return;
    }
  }

  onSave(expiryData, expiryAlert, alertDays, productIndex);
  onClose();
};

  const handleClose = () => {

    const filteredData = expiryData.filter(
      (item) =>
        item.batchNumber ||
        item.qty ||
        item.manufactureDate ||
        item.shelfLife ||
        item.expiryDate
    );

    setExpiryData(filteredData);
    onClose();
  };

const isButtonDisabled = expiryData.every((item) => {
  return (
    !item.batchNumber ||
    !item.qty ||
    !item.expiryDate
  );
});

const handleDeleteRow = (index) => {
  const updated = [...expiryData];
  updated.splice(index, 1);
  setExpiryData(updated);
};

const calculateShelfLife = (manufactureDate, expiryDate) => {
  if (!manufactureDate || !expiryDate) return "";

  const mfg = moment(manufactureDate?.toDate ? manufactureDate.toDate() : manufactureDate);
  const exp = moment(expiryDate?.toDate ? expiryDate.toDate() : expiryDate);

  const diff = exp.startOf("day").diff(mfg.startOf("day"), "days");

  return diff >= 0 ? diff : 0;
};

  return (
    <Modal
      title={t("Expiry")}
      visible={visible}
      onCancel={handleClose}
      footer={null}
      width={900}
    >
      <div className="expiry-page">
     <div className="flex mb-2 gap-2 flex-wrap">
      <div  style={{ width: "90px" }}>
      {t("Quantity")}<span className="text-red ">*</span>
      </div>
       <div   style={{ width: "140px" }}>
      {t("Batch Number")}<span className="text-red ">*</span>
      </div>
       <div    style={{ width: "190px" }}>
      {t("Manufacture Date")}
      </div>
       <div   style={{ width: "140px" }}>
      {t("Shelf Life (Days)")}
      </div>
       <div  style={{ width: "190px" }}>
      {t("Expiry Date")}<span className="text-red ">*</span>
      </div>
     </div>
        {expiryData.map((item, index) => (
          <div key={index} className="flex mb-2 gap-2 flex-wrap">

           

            <Input
              type="number"
              placeholder={t("Qty")}
              value={item.qty}
              onChange={(e) => handleChange(index, "qty", e.target.value)}
              onWheel={(e) => e.target.blur()}
              min={0}
              style={{ width: "90px" }}
            />
             <Input
              placeholder={t("Batch Number")}
              value={item.batchNumber}
              onChange={(e) =>
                handleChange(index, "batchNumber", e.target.value)
              }
              style={{ width: "140px" }}
              disabled={!item.qty}
            />

            <DatePicker
              placeholder={t("Manufacture Date")}
              value={item.manufactureDate}
              onChange={(date) =>
                handleManufactureDateChange(index, date)
              }
              style={{ width: "190px" }}
              disabled={!item.qty }
               disabledDate={(current) => {
    if (!item.expiryDate) return false;

    return current.isAfter(item.expiryDate, "day");
  }}
            />

            <Input
              type="number"
              placeholder={t("Shelf Life (Days)")}
              value={item.shelfLife}
              onChange={(e) =>
                handleChange(index, "shelfLife", e.target.value)
              }
              min={0}
              style={{ width: "140px" }}
             disabled={!item.manufactureDate || !item.qty || (item.manufactureDate && item.expiryDate)}
             
            />

            <DatePicker
              placeholder={t("Expiry Date")}
              value={item.expiryDate}
              onChange={(date) => {
                handleDateChange(index, date)}}
                  style={{ width: "190px" }}
              disabled={!item.qty }
              disabledDate={(current) => {
    if (!item.manufactureDate) return false;

    return current.isBefore(item.manufactureDate, "day");
  }}
            />
            {index != 0 && 
             <img
                  className={`mx-4 h-4 w-4 mt-2 cursor-pointer`} // Change appearance if disabled
                  src={deleteicon}
                  alt="deleteicon"
                   onClick={() => handleDeleteRow(index)}
                  // onClick={() => !disabled && handleDeleteProduct(row.index)} // Only allow click if not disabled
                />
            }
     
          </div>
        ))}

        <Button
          onClick={handleAddRow}
          type="dashed"
          style={{ marginBottom: "10px" }}
        >
          {t("Add")} +
        </Button>

        {/* <div>
          <span>{t("Expiry Alert")}</span>

          <Switch
            checked={expiryAlert}
            className={`ms-2 ${
              expiryAlert ? "bg-primaryBlue" : "bg-gray-400"
            }`}
            onChange={setExpiryAlert}
          />

          {expiryAlert && (
            <>
              <Input
                placeholder={t("XX Days")}
                value={alertDays}
                onChange={(e) => setAlertDays(e.target.value)}
                className="w-20 ms-2"
              />
              <span className="ms-2">{t("Days")}</span>
            </>
          )}
        </div> */}

        <div className="flex justify-end font-semibold mt-4">
          <Button
            onClick={handleSave}
            className="bg-primaryBlue"
            type="primary"
            disabled={isButtonDisabled}
          >
            {t("save")}
          </Button>
        </div>

      </div>
    </Modal>
  );
};

export default ExpiryModal;